import { useTranslation } from 'react-i18next'

import Button from '../../../Button'
import {
  useDocFlowContext,
  useDocFlowMappingContext,
} from '../../DocFlow.hooks'
import { isDocFlowActiveWidgetResult } from '../../DocFlow.utils.widgets'
import { isDocFlowMappingResetButtonDisabled } from '../../DocFlowMapping'
import { NextPhaseButton } from '../../DocFlowProfileHeaderActions'

import * as styles from './AdditionalButtons.module.css'

function AdditionalButtons({ isSplitting }) {
  const { t } = useTranslation()

  const { handleNextPhase, phaseDisabled } = useDocFlowContext()

  const {
    activeWidget,
    handleResetProcess,
    isMappedDataLoading,
    loadingFileBytes,
    nextButtonProps,
    nextPhaseDisabled,
    processData,
  } = useDocFlowMappingContext()

  const resetButtonDisabled =
    isDocFlowMappingResetButtonDisabled(processData) || isMappedDataLoading

  const isResult = isDocFlowActiveWidgetResult(activeWidget)

  return (
    <div className={styles.AdditionalButtons}>
      {isSplitting ? (
        <Button.Contained
          isLight
          disabled={resetButtonDisabled || phaseDisabled}
          text={t('DocumentStapling.ResetProccessBtnKey')}
          onClick={handleResetProcess}
        />
      ) : null}
      {!nextPhaseDisabled &&
      (isResult || !isSplitting) &&
      !!processData &&
      !loadingFileBytes ? (
        <NextPhaseButton
          {...nextButtonProps}
          text='DocumentStapling.ProfileNextPhaseBtnKey'
          onNextPhase={handleNextPhase}
        />
      ) : null}
    </div>
  )
}

export default AdditionalButtons
